export const CHANGE_THEME = "app/CHANGE_THEME";

export const SET_TOUR = "app/SET_TOUR";

export const SEARCH_VALUE = "app/SEARCH_VALUE";

export const TOGGLE_PROFILE = "app/TOGGLE_PROFILE";
export const CLOSE_PROFILE = "app/CLOSE_PROFILE";

export const CLOSE_DRAWER = "app/CLOSE_DRAWER";
export const TOGGLE_DRAWER = "app/TOGGLE_DRAWER";

export const LOG_OUT_REQUESTED = "app/LOG_OUT_REQUESTED";
export const LOG_OUT_SUCCESS = "app/LOG_OUT_SUCCESS";
export const LOG_OUT_FAILED = "app/LOG_OUT_FAILED";

export const SIGN_IN_REQUESTED = "app/SIGN_IN_REQUESTED";
export const SIGN_IN_SUCCESS = "app/SIGN_IN_SUCCESS";
export const SIGN_IN_FAILED = "app/SIGN_IN_FAILED ";

export const GET_PROFILE_REQUESTED = "app/GET_PROFILE_REQUESTED";
export const GET_PROFILE_SUCCESS = "app/GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "app/GET_PROFILE_FAILED ";

export const GET_SEARCH_HISTORY_RESULT_REQUESTED = "app/GET_SEARCH_HISTORY_RESULT_REQUESTED";
export const GET_SEARCH_HISTORY_RESULT_SUCCESS = "app/GET_SEARCH_HISTORY_RESULT_SUCCESS";
export const GET_SEARCH_HISTORY_RESULT_FAILED = "app/GET_SEARCH_HISTORY_RESULT_FAILED ";

export const SET_NOTIFICATIONS_SEEN_REQUESTED = "app/SET_NOTIFICATIONS_SEEN_REQUESTED";
export const SET_NOTIFICATIONS_SEEN_SUCCESS = "app/SET_NOTIFICATIONS_SEEN_SUCCESS";
export const SET_NOTIFICATIONS_SEEN_FAILED = "app/SET_NOTIFICATIONS_SEEN_FAILED ";

export const SET_NOTIFICATIONS_SEEN = "app/SET_NOTIFICATIONS_SEEN ";

export const TOGGLE_LOGIN_SIGNUP_MODAL = "app/TOGGLE_LOGIN_SIGNUP_MODAL";

export const CHECKED_ACCESS_SIGNUP = "app/CHECKED_ACCESS_SIGNUP";
export const CHECKED_ACCESS_LOGIN = "app/CHECKED_ACCESS_LOGIN";

export const TOAST_ERROR = "app/TOAST_ERROR";
export const TOAST_SUCCESS = "app/TOAST_SUCCESS";
export const TOAST_WARNING = "app/TOAST_WARNING";

export const FORGET_PASSWORD_STEP = "app/FORGET_PASSWORD_STEP";

export const SET_ACTIVITY_LIST_TAB2 = "app/SET_ACTIVITY_LIST_TAB2";

export const SET_ALL_TAB_PAGE_ONE = "app/SET_ALL_TAB_PAGE_ONE";

export const SET_RESET_TAB_2 = "app/SET_RESET_TAB_2";

export const GET_MY_BOOM_REQUESTED = "app/GET_MY_BOOM_REQUESTED";
export const GET_MY_BOOM_SUCCESS = "app/GET_MY_BOOM_SUCCESS";
export const GET_MY_BOOM_FAILED = "app/GET_MY_BOOM_FAILED";

export const GET_EXTRA_MY_BOOM_REQUESTED = "app/GET_EXTRA_MY_BOOM_REQUESTED";
export const GET_EXTRA_MY_BOOM_SUCCESS = "app/GET_EXTRA_MY_BOOM_SUCCESS";
export const GET_EXTRA_MY_BOOM_FAILED = "app/GET_EXTRA_MY_BOOM_FAILED";

export const GET_ACTIVITY_SEARCH_REQUESTED = "app/GET_ACTIVITY_SEARCH_REQUESTED";
export const GET_ACTIVITY_SEARCH_SUCCESS = "app/GET_ACTIVITY_SEARCH_SUCCESS";
export const GET_ACTIVITY_SEARCH_FAILED = "app/GET_ACTIVITY_SEARCH_FAILED";

export const SET_TRUE_FOR_HAS_MORE_2 = "app/SET_TRUE_FOR_HAS_MORE_2";

export const SET_SEARCH_ACTIVITY_QUERY = "app/SET_SEARCH_ACTIVITY_QUERY ";

export const GET_EXTRA_ACTIVITY_SEARCH_REQUESTED = "app/GET_EXTRA_ACTIVITY_SEARCH_REQUESTED";
export const GET_EXTRA_ACTIVITY_SEARCH_SUCCESS = "app/GET_EXTRA_ACTIVITY_SEARCH_SUCCESS";
export const GET_EXTRA_ACTIVITY_SEARCH_FAILED = "app/GET_EXTRA_ACTIVITY_SEARCH_FAILED";

export const GET_MY_ACTIVITY_REQUESTED = "app/GET_MY_ACTIVITY_REQUESTED";
export const GET_MY_ACTIVITY_SUCCESS = "app/GET_MY_ACTIVITY_SUCCESS";
export const GET_MY_ACTIVITY_FAILED = "app/GET_MY_ACTIVITY_FAILED";

export const GET_MY_FOLLOWING_REQUESTED = "app/GET_MY_FOLLOWING_REQUESTED";
export const GET_MY_FOLLOWING_SUCCESS = "app/GET_MY_FOLLOWING_SUCCESS";
export const GET_MY_FOLLOWING_FAILED = "app/GET_MY_FOLLOWING_FAILED";

export const GET_SUGGESTED_FOLLOWING_LIST_REQUESTED = "app/GET_SUGGESTED_FOLLOWING_LIST_REQUESTED";
export const GET_SUGGESTED_FOLLOWING_LIST_SUCCESS = "app/GET_SUGGESTED_FOLLOWING_LIST_SUCCESS";
export const GET_SUGGESTED_FOLLOWING_LIST_FAILED = "app/GET_SUGGESTED_FOLLOWING_LIST_FAILED";

export const SET_MY_ACTIVITY_FILTER = "app/SET_MY_ACTIVITY_FILTER";
export const SET_MY_ACTIVITY_LIST = "app/SET_MY_ACTIVITY_LIST";

export const REMOVE_MY_ACTIVITY = "app/REMOVE_MY_ACTIVITY";

export const SET_SCROLL_TO_BOOM = "addActivity/SET_SCROLL_TO_BOOM";
export const SET_SCROLL_TO_SEARCH = "addActivity/SET_SCROLL_TO_SEARCH";
export const SET_SCROLL_TO_MY_ACTIVITY = "addActivity/SET_SCROLL_TO_MY_ACTIVITY";

export const SET_SEARCH_FILTER_DRAWER_OPEN = "addActivity/SET_SEARCH_FILTER_DRAWER_OPEN";
export const SET_SEARCH_FILTER_DRAWER_OPEN_MOBILE = "addActivity/SET_SEARCH_FILTER_DRAWER_OPEN_MOBILE";
export const SET_MY_ACTIVITY_FILTER_DRAWER_OPEN_MOBILE = "addActivity/SET_MY_ACTIVITY_FILTER_DRAWER_OPEN_MOBILE";
export const SET_MESSAGING_OPEN_MOBILE_BLUR = "addActivity/SET_MESSAGING_OPEN_MOBILE_BLUR";

//home
export const HOME_DATA_REQUESTED = "app/HOME_DATA_REQUESTED";
export const HOME_DATA_SUCCESS = "app/HOME_DATA_SUCCESS";
export const HOME_DATA_FAILED = "app/HOME_DATA_FAILED";
//school
export const SCHOOL_DATA_REQUESTED = "app/SCHOOL_DATA_REQUESTED";
export const SCHOOL_DATA_SUCCESS = "app/SCHOOL_DATA_SUCCESS";
export const SCHOOL_DATA_FAILED = "app/SCHOOL_DATA_FAILED";
//election
export const RESET_ELECTION = "app/RESET_ELECTION";
